<template>
  <section class="has-background-info px-5">
    <div class="container is-max-desktop">
      <div class="columns is-multiline">
        <div class="column is-8 is-full-mobile my-3">
          <p><strong>Encuentra tu sucursal</strong></p>

          <div class="field">
            <label for="seleccionar_region" class="label">Región:</label>
            <div class="control">
              <span class="select is-fullwidth is-empty">
                <select v-model="selectedRegion" id="seleccionar_region" required>
                  <option disabled value="">Seleccionar región</option>
                  <option v-for="region in regions" :key="region.value" :value="region.value">
                    {{ region.name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div class="field">
            <label for="seleccionar_comuna" class="label">Comuna:</label>
            <div class="control">
              <span class="select is-fullwidth is-empty">
                <select v-model="selectedComuna" id="seleccionar_comuna" required>
                  <option disabled value="">Seleccionar comuna</option>
                  <option v-for="comuna in filteredComunas" :key="comuna.value" :value="comuna.value">
                    {{ comuna.name }}
                  </option>
                </select>
              </span>
            </div>
          </div>

          <div class="cont-btn">
            <button type="button" class="button is-primary buscarSucursal is-pulled-right mb-3" :disabled="isDisabled"
              @click="emitUpdates()">Buscar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SucursalBuscar',
  props: {
    data: {
      type: Object,
      required: true
    },
    comunas: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      selectedRegion: "",
      selectedComuna: "",
      regions: [],
      filteredComunas: [],
      activeRegion: "",
      activeComuna: "",
    }
  },
  computed: {
    isDisabled() {
      if (this.selectedComuna === "" || this.selectedRegion === "") {
        return true;
      }
      return false;
    },
    filteredOffices() {
      if (this.activeComuna === "" || this.activeRegion === "") return [];

      const selectedComuna = this.comunas.find(comuna => comuna.value === this.activeComuna);
      if (!selectedComuna) return [];

      let officesFiltered = this.data.offices.filter(office =>
        office.location_id.startsWith(this.activeComuna)
      );

      return officesFiltered;
    },
    filteredOfficesRegion() {
      if (this.activeComuna === "" || this.activeRegion === "") return [];

      const selectedComuna = this.comunas.find(comuna => comuna.value === this.activeComuna);
      if (!selectedComuna) return [];

      const comunasInRegion = this.comunas.filter(comuna =>
        comuna.value.startsWith(this.activeRegion)
      );

      const officesInRegion = this.data.offices.filter(office => {
        return comunasInRegion.some(comuna =>
          office.location_id.startsWith(comuna.value)
        );
      });

      return officesInRegion;
    },
  },
  watch: {
    selectedRegion(newRegion) {
      if (!this.selectedComuna.startsWith(newRegion)) {
        this.selectedComuna = "";
      }
      this.filteredComunas = newRegion
        ? this.comunas.filter(comuna => comuna.value.startsWith(newRegion))
        : [];
    },
  },
  mounted() {
    this.initializeRegions();
    this.initializeFromURL();
  },
  methods: {
    initializeRegions() {
      this.regions = _.chain(this.data.location)
        .filter(item => item.type === 'region')
        .map(region => ({
          value: region.id,
          name: region.name
        }))
        .value();
    },
    async initializeFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const regionParam = urlParams.get('region');
      const comunaParam = urlParams.get('comuna');

      if (regionParam && comunaParam) {
        await this.$nextTick();

        // Verificar validez de parámetros antes de cualquier asignación
        if (!this.isValidLocationParams(regionParam, comunaParam)) {
          this.clearLocationAndParams();
          return;
        }

        this.selectedRegion = regionParam;
        await this.$nextTick();
        this.selectedComuna = comunaParam;
        this.activeRegion = regionParam;
        this.activeComuna = comunaParam;
        this.emitUpdates();
      }
    },

    clearLocationAndParams() {
      this.selectedRegion = "";
      this.selectedComuna = "";
      this.activeRegion = "";
      this.activeComuna = "";

      const url = new URL(window.location.href);
      url.searchParams.delete('region');
      url.searchParams.delete('comuna');
      window.history.replaceState(null, '', url);

      this.emitUpdates();
    },

    isValidLocationParams(region, comuna) {
      if (!region || !comuna || !(/^\d+$/.test(region)) || !(/^\d+$/.test(comuna))) {
        return false;
      }

      // Verificar que la región existe
      const regionExists = this.regions.some(r => r.value === region);
      if (!regionExists) {
        return false;
      }

      // Verificar que la comuna existe y pertenece a la región
      const comunaExists = this.comunas.some(c =>
        c.value === comuna && comuna.startsWith(region)
      );
      return comunaExists;
    },

    updateURLParams() {
      const url = new URL(window.location.href);

      if (this.isValidLocationParams(this.activeRegion, this.activeComuna)) {
        url.searchParams.set('region', this.activeRegion);
        url.searchParams.set('comuna', this.activeComuna);
      } else {
        url.searchParams.delete('region');
        url.searchParams.delete('comuna');
      }

      window.history.replaceState(null, '', url);
    },

    emitUpdates() {
      this.activeRegion = this.selectedRegion;
      this.activeComuna = this.selectedComuna;

      this.$emit('update:filteredOffices', this.filteredOffices);
      this.$emit('update:filteredOfficesRegion', this.filteredOfficesRegion);
      this.$emit('update:selectedLocation', {
        region: this.activeRegion,
        comuna: this.activeComuna
      });

      this.updateURLParams();
    }
  }
}
</script>
